//
// Role.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "../core/styles/attributesMap/AbstractAttributesMap";
import "./ConstantValue";

var Role = createModule("gtl::Role", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        dataField: 7,
        tipLabel: 7,
        attributesMap: 1,
        tipFormat: 7,
        constantValue: 1,
    },
    ,
    ,
    {
        isConstantRole: [2],
    },
    {
        _create_v: [4],
        _create_o: [4,1],
    },
    ,
    ["_create"]
]);
export default Role;
